export enum WEB_APP_EVENTS {
    GET_USER_TRACKER_INFO = 'web.app.events.get.user.tracker.info',
    LOGIN_SUCCESS = 'web.app.events.login.success',
    USER_PROFILE_LOADED = 'web.app.events.user.profile.loaded',
    TOKEN_EXPIRED = 'web.app.events.user.token.expired'
};